module.exports = __webpack_public_path__ + "static/media/groupMemberBlackIcon.4da53006.svg";